var exports = {
  "wrapper": "xaee3c4fa--a11c90--wrapper",
  "border": "xaee3c4fa--a11c90--border",
  "_gray": "xaee3c4fa--a11c90--_gray",
  "_orange": "xaee3c4fa--a11c90--_orange",
  "text": "xaee3c4fa--a11c90--text",
};

module.exports = exports;
